import React from 'react';
import ExpandingInfo from './components/calculators-layout/ExpandingInfo';
import CalculatorForm from './components/calculators-layout/CalculatorForm';
import CalculatorLayout from './components/calculators-layout/CalculatorLayout';
import CalculatorResultCard from './components/calculators-layout/CalculatorResultCard';
import InputWithLabel from '../LoanApplication/components/commons/InputWithLabel';
import RepaymentYear from '../../components/RepaymentYear';
import RepaymentFrequency from './components/BorrowAmount/RepaymentFrequency';
import CalculatorCallToActionCard from './components/calculators-layout/CalculatorCallToActionCard';
import {postMortgageRepayment} from './api';
import currencyFormatter from '../../utils/currencyFormatter';
import ReusableGraph from './components/ReusableGraph/ReusableGraph';
import reusableLineGraphConfig from './components/ReusableGraph/reusableLineGraphConfig';
import dataPeriods from './utils/dataPeriods';
import CalculatorAssumptions from './components/calculators-layout/CalculatorAssumptions';
import MortgageRepaymentAssumptionContent from './AssumptionBoxContent/MortgageRepaymentAssumptionContent';
const currentInterestRate = I18n.t('calculators.interest_matrix.live.regular.payg_variable')[0];

class MortgageRepaymentCalculator extends React.Component {
  state = {
    type: 'own_home',
    currentLoanAmount: 500000,
    remainingLoanTerm: 30,
    currentInterestRate,
    repaymentFrequency: 'monthly',
    errors: {},
    results: {
      repaymentFrequency: 'monthly',
      fortnightlyMortgageRepaymentLabel: 0,
      monthlyMortgageRepaymentLabel: 0,
      weeklyMortgageRepaymentLabel: 0,
      totalInterestPayableOverTermLabel: 0,
      totalPaymentOverTermLabel: 0,
      totalPaymentOverTermMonthly: 0,
      totalPaymentOverTermFortnightly: 0,
      totalPaymentOverTermWeekly: 0,
      totalInterestPayableOverTermMonthly: 0,
      totalInterestPayableOverTermFortnightly: 0,
      totalInterestPayableOverTermWeekly: 0,
      lineGraphDataYearly: [],
      remainingLoanTerm: 30
    }
  };
  
  onCalculationSuccess = (response) => {
    const {repaymentFrequency, remainingLoanTerm} = this.state
    this.setState({
      results: {remainingLoanTerm, repaymentFrequency, ...response.data},
    })
  };

  onCalculationFailure = ({ response }) => {
    let errors = response.data.errors;

    let swalTitle = I18n.t('calculators.generic_error.title');
    let swalText = I18n.t('calculators.generic_error.description');

    if ((response.status) == 422) {
      swalTitle = I18n.t('calculators.generic_error.title');
      swalText = response.data.errors
    }

    swal({
      title: swalTitle,
      text: swalText,
      type: 'warning',
      showCancelButton: false,
      confirmButtonText: 'Close',
      allowOutsideClick: false,
      confirmButtonColor: "#10c98f",
    })
  };

  onCalculationSubmit = (calculateXAxis = false) => {
    let data = {
      mortgageRepay: {...this.state, currentInterestRate: this.state.currentInterestRate * 0.01}
    }
    delete data.mortgageRepay.results
    delete data.mortgageRepay.errors
    delete data.mortgageRepay.type
    
    postMortgageRepayment(
      data,
      this.onCalculationSuccess,
      this.onCalculationFailure
    )
  };

  repaymentFigures = () => {
    const { results } = this.state;
    switch (results.repaymentFrequency) {
      case 'monthly':
        return {
          repaymentAmount: results.monthlyMortgageRepaymentLabel,
          repaymentFrequency: results.repaymentFrequency,
          totalInterestPaid: results.totalInterestPayableOverTermMonthly,
          totalPrincipalAndInterestPaid: results.totalPaymentOverTermMonthly,
        }
      case 'fortnightly':
        return {
          repaymentAmount: results.fortnightlyMortgageRepaymentLabel,
          repaymentFrequency: results.repaymentFrequency,
          totalInterestPaid: results.totalInterestPayableOverTermFortnightly,
          totalPrincipalAndInterestPaid: results.totalPaymentOverTermFortnightly,
        }
      case 'weekly':
        return {
          repaymentAmount: results.weeklyMortgageRepaymentLabel,
          repaymentFrequency: results.repaymentFrequency,
          totalInterestPaid: results.totalInterestPayableOverTermWeekly,
          totalPrincipalAndInterestPaid: results.totalPaymentOverTermWeekly,
        }
    }
  }
  
  componentDidMount = () => {
    this.onCalculationSubmit()
  };
  
  expandingLead = (
    <p>You can use our home loan payment calculator as a guide to what your mortgage repayments could be a new home loan.</p>
  );
  
  expandingInfoContent = (
    <React.Fragment>
      <p>
        This online mortgage calculator provides an estimate of:
      </p>
      <ul>
        <li>Your loan repayment</li>
        <li>The total amount of interest you will pay over the life of the loan</li>
        <li>The speed at which you will pay down the principal over the life of the loan</li>
      </ul>
      <p>To get started, enter your required loan amount, loan term, interest rate and loan repayment frequency. The calculator assumes that you are making principal & interest repayments towards your loan.</p>
      <p>The next step from here is to understand whether you meet the borrowing capacity for your requested loan amount.</p>
    </React.Fragment>
  );
  calculatorForm() {
    const {currentLoanAmount, errors, remainingLoanTerm, currentInterestRate} = this.state;
    return (
      <React.Fragment>
        <div className="numeric-input">
          <InputWithLabel
            label='Loan amount'
            type='currency'
            defaultValue={currentLoanAmount}
            errorMessage={errors['currentLoanAmount']}
            onChange={(value) => this.setState({currentLoanAmount: value})}
          />
        </div>
        <RepaymentYear
          isDreamSpace={this.props.isDreamSpace}
          label='Loan term (years)'
          defaultValue={remainingLoanTerm}
          max={40}
          marks={{
            0:  { style: { fontSize: '17px' }, label: 0 },
            5:  { style: { fontSize: '17px' }, label: 5 },
            10: { style: { fontSize: '17px' }, label: 10 },
            15: { style: { fontSize: '17px' }, label: 15 },
            20: { style: { fontSize: '17px' }, label: 20 },
            25: { style: { fontSize: '17px' }, label: 25 },
            30: { style: { fontSize: '17px' }, label: 30 },
            35: { style: { fontSize: '17px' }, label: 35 },
            40: { style: { fontSize: '17px' }, label: 40 },
          }}
          onChange={(value) => this.setState({remainingLoanTerm: value})}
        />
        <div className="rate-input">
          <InputWithLabel
            label='Interest rate'
            type='append'
            appendText={ '%' }
            defaultValue={currentInterestRate}
            errorMessage={errors['currentInterestRate']}
            onChange={(value) => this.setState({currentInterestRate: value})}
          />
        </div>
        <div className='calculator-toggle-group triple'>
          <RepaymentFrequency
            isDreamSpace={this.props.isDreamSpace}
            onClick={(value) => this.setState({repaymentFrequency: value})}/>
        </div>
      </React.Fragment>
    );
  }
  resultsColumn() {
    const {results} = this.state;
    const {totalPaymentOverTermLabel, totalInterestPayableOverTermLabel} = results;
    const graphProps = {
      graphData: results.lineGraphDataYearly,
      loanTerm: results.remainingLoanTerm,
      ...reusableLineGraphConfig
    }
    const {repaymentAmount, repaymentFrequency, totalInterestPaid, totalPrincipalAndInterestPaid} = this.repaymentFigures();
    
    return results ? <div>
      <CalculatorResultCard
        caption='You would be repaying'
        isDreamSpace={this.props.isDreamSpace}
        figure={repaymentAmount}
        figureText={repaymentFrequency}
        additionalInfo={(
          <React.Fragment>
            <p>Total interest paid: <strong>{currencyFormatter.format(totalInterestPaid)}</strong></p>
            <p>Total principal & interest paid: <strong>{currencyFormatter.format(totalPrincipalAndInterestPaid)}</strong></p>
          </React.Fragment>
        )}
      />
      <CalculatorCallToActionCard isDreamSpace={this.props.isDreamSpace}>
        <div className='mortgage-repayment-calculator__cta'>
          <p className='can-i-borrow'>Can I borrow</p>
          <p className='amount'>{currencyFormatter.format(this.state.currentLoanAmount)}?</p>
        </div>
      </CalculatorCallToActionCard>
        <ReusableGraph graphProps={graphProps} isDreamSpace={this.props.isDreamSpace} />
    </div> : null;  
  }
  
  render() {
    const { isDreamSpace } = this.props;
    return (
      <div className="mortgage-repayment-calculator">
        <CalculatorLayout
          infoRow={<ExpandingInfo
                     lead={this.expandingLead}
                     isDreamSpace={isDreamSpace}>{this.expandingInfoContent}
                   </ExpandingInfo>
                  }
          formColumn={<CalculatorForm
                        handleSubmit={this.onCalculationSubmit}
                        isDreamSpace={isDreamSpace}
                      >
                          {this.calculatorForm()}
                      </CalculatorForm>
                     }
          resultsColumn={this.resultsColumn()}
        >
          <CalculatorAssumptions
            assumptionBoxContents={<MortgageRepaymentAssumptionContent />}
            isDreamSpace={isDreamSpace}
          />
        </CalculatorLayout>
      </div>
    );
  }
}

export default MortgageRepaymentCalculator;
